
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcKeyboardNumeric as ObcKeyboardNumericElement} from '@oicl/openbridge-webcomponents/dist/components/keyboard-numeric/keyboard-numeric.js';
 
 
 

 
 export const ObcKeyboardNumeric = createComponent({
   react: React,
   tagName: 'obc-keyboard-numeric',
   elementClass: ObcKeyboardNumericElement,
   events: {
     
   }
  });
 
 